module.exports = __webpack_public_path__ + "img/l-hd.19dab963.jpg";